<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Location</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">
                  This is location menu to setup point location
                </p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>
    </div>
    <!-- / .header -->

    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <div class="card">
            <div class="card-header">
              <!-- Title -->
              <h4 class="card-header-title">Location</h4>

              <!-- Switch -->
              <div class="form-check form-switch">
                <button
                  class="btn btn-success"
                  @click.prevent="$router.push('/location/create')"
                >
                  <i class="fe fe-plus-circle"></i>
                  <span class="ms-2">Create new point</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="d-flex justify-content-end mb-3">
                <label class="align-self-center mb-0 mr-3">Search</label>
                <b-form-input v-model="searchTerm" class="w-auto" placeholder="Type Here..."></b-form-input>
              </div>
              <vue-good-table
                :columns="columns"
                :rows="list"
                :line-numbers="true"
                :search-options="{
                  enabled: true,
                  externalQuery: searchTerm,
                }"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength,
                }">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'created_at'">
                    {{ formatDate(props.row.created_at) }}
                  </span>
                  <span v-else-if="props.column.field == 'updated_at'">
                    {{ formatDate(props.row.updated_at) }}
                  </span>
                  <div
                    v-else-if="props.column.field == 'qrcode'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-primary"
                      @click.prevent="viewQR(props.row.qr_code)"
                    >
                      View QR
                    </button>
                  </div>
                  <div
                    v-else-if="props.column.field == 'action'"
                    class="text-center"
                  >
                    <button
                      class="btn btn-sm btn-warning me-2"
                      @click.prevent="
                        $router.push(`/location/${props.row.id}/update`)
                      "
                    >
                      Edit
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      @click.prevent="remove(props.row.id)"
                    >
                      Delete
                    </button>
                  </div>
                </template>
                <template slot="pagination-bottom" slot-scope="props">
                  <div class="d-flex justify-content-end">
                    <div>
                      <b-pagination
                        :value="1"
                        :total-rows="props.total"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="m-3"
                        @input="(value) => props.pageChanged({ currentPage: value })"
                      >
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
      <!-- / .row -->
    </div>
    <ModalQR />
  </div>
  <!-- / .main-content -->
</template>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";
import QRcode from "qrcode.vue";
import ModalQR from "./modalQRCode.vue";

export default {
  name: "locationComponent",
  computed: {
    columns() {
      return this.$store.getters["location/columns"];
    },
    list() {
      return this.$store.getters["location/list"];
    },
  },
  components: {
    ModalQR,
    QRcode,
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
    };
  },
  mounted() {
    console.log(this);
    this.getList();
  },
  methods: {
    viewQR(code) {
      this.$store.commit("location/SET_QR_CODE", code);
      this.$bvModal.show("view-qr");
    },
    getList() {
      this.$store.dispatch("location/GET_LIST");
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("YYYY/MM/DD HH:mm:ss");
      }
      return date;
    },
    remove(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("location/DELETE", { id: id }).then(() => {
            this.$swal("Deleted!", "Location Deleted!.", "success");
            this.getList();
          });
        }
      });
    },
  },
};
</script>
